var keyMirror = require('keymirror');

module.exports = keyMirror({
	STACKED_AREA_COPY: null,
	STACKED_CSV_COPY: null
});